import { render, staticRenderFns } from "./desc-item.vue?vue&type=template&id=0bcc8eb8&scoped=true"
import script from "./desc-item.vue?vue&type=script&lang=js"
export * from "./desc-item.vue?vue&type=script&lang=js"
import style0 from "./desc-item.vue?vue&type=style&index=0&id=0bcc8eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc8eb8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/tariff/bottom-desc/desc-item.vue
// module id = null
// module chunks = 